import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthenticationEffects } from './state/authenication.effects';
import { authenticationFeatureKey, reducer } from './state/authentication.reducer';

@NgModule({
   imports: [
      MatDialogModule,
      StoreModule.forFeature(authenticationFeatureKey, reducer),
      EffectsModule.forFeature([AuthenticationEffects]),
   ],
})
export class AuthenticationModule {}
